import { createGlobalStyle } from "styled-components";
import SFProRoundedBold from "./sf-pro/sf-pro-display-bold.woff2";
import SFProRoundedRegular from "./sf-pro/sf-pro-display-regular.woff2";
import SFProRoundedMedium from "./sf-pro/sf-pro-display-medium.woff2";
import SFProRoundedSemibold from "./sf-pro/sf-pro-display-semibold.woff2";

const FontStyles = createGlobalStyle`

  @font-face {
    font-family: 'SFProRounded';
    font-style: normal;
    font-weight: 400;
    src: url(${SFProRoundedRegular}) format('woff2');
  }

  @font-face {
    font-family: 'SFProRounded';
    font-style: normal;
    font-weight: 500;
    src: url(${SFProRoundedMedium}) format('woff2');
  }

  @font-face {
    font-family: 'SFProRounded';
    font-style: normal;
    font-weight: 600;
    src: url(${SFProRoundedSemibold}) format('woff2');
  }

  @font-face {
    font-family: 'SFProRounded';
    font-style: normal;
    font-weight: 700;
    src: url(${SFProRoundedBold}) format('woff2');
  }

`;

export default FontStyles;